import { AppState } from 'reducers';

export const getOverlayData = (state: AppState) => state.overlay;
